module.exports = __webpack_public_path__ + "static/media/cover.28529a74.jpg";